export enum GameType {
  ODD = "odd",
  EVEN = "even",
  ALL = "all"
}
